export const WebsiteUrl="https://percentager.net"
export const PercentageListUrl = "calculate_percentage_of_any_number_from_1_to_100"
export const PercentageEndPoint="percent_calculator"
export const LangaugesUrl = "languages"